import React, { useMemo } from 'react';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import ActionToolbar from '../common/ActionToolbar';

/**
 * ConfirmedOrdersActions
 * Actions toolbar for Confirmed Orders: search and refresh only.
 */
const ConfirmedOrdersActions = ({
  showSearch = true,
  searchValue = '',
  onSearchChange,
  onRefresh,
  loading = false,
  refreshLoading = false,
}) => {
  const { t } = useTranslation();

  const actions = useMemo(() => [
    {
      key: 'refresh-confirmed-orders',
      label: t('ordersModule.common.buttons.refresh'),
      icon: faRefresh,
      onClick: onRefresh,
      disabled: refreshLoading,
      variant: 'ghost',
      showLabelBreakpoint: 'sm',
      spinner: refreshLoading,
    },
  ], [onRefresh, refreshLoading, t]);

  return (
    <ActionToolbar
      showSearch={showSearch}
      searchValue={searchValue}
      onSearchChange={onSearchChange}
      searchPlaceholder={t('ordersModule.orders.actions.searchPlaceholder')}
      filters={[]}
      actions={actions}
    />
  );
};

export default ConfirmedOrdersActions;
